import { useEffect, useState } from "react";
import { useAuth } from "@/_core/hooks/useAuth";

export type AuthContactFields = {
  name: string;
  email: string;
  phone: string;
};

function preferTyped(current: string, incoming: string | null | undefined): string {
  return current.trim() ? current : incoming?.trim() || "";
}

/** Keep a value the visitor already typed; otherwise use the signed-in account field. */
export function fillContactFromAuth(
  current: AuthContactFields,
  auth: { name?: string | null; email?: string | null; phone?: string | null } | null,
): AuthContactFields {
  if (!auth) return current;
  return {
    name: preferTyped(current.name, auth.name),
    email: preferTyped(current.email, auth.email),
    phone: preferTyped(current.phone, auth.phone),
  };
}

export function useAuthContactFields() {
  const { user } = useAuth();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");

  useEffect(() => {
    if (!user) return;
    setName((current) => preferTyped(current, user.name));
    setEmail((current) => preferTyped(current, user.email));
    setPhone((current) => preferTyped(current, user.phone));
  }, [user]);

  return { name, setName, email, setEmail, phone, setPhone };
}
